// import { AppPalette } from '../../colors'

export const MuiSelect = {
  styleOverrides: {
    root: {
      // Select-main
      '&.select-main fieldset': {
        backgroundColor: 'rgb(249, 249, 249)',
        '&:hover': {
          backgroundColor: 'rgb(243, 244, 246)',
        },
      },
      '&.select-main .MuiSelect-outlined': {
        color: 'text.main',
        fontSize: '12px',
        fontWeight: '500',
        zIndex: '1',
      },
      // Select-non-border
      '&.select-non-border': {
        fontSize: '12px',
        height: '32px',
        fontWeight: '500',
        '.MuiOutlinedInput-notchedOutline': { borderColor: 'transparent ' },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
          backgroundColor: 'rgb(243, 244, 246)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
      },
      '&.select-non-border .MuiSelect-outlined , &.select-non-border .MuiSvgIcon-root':
        {
          zIndex: '1',
          color: 'text.main',
        },
    },
  },
}
